// extracted by mini-css-extract-plugin
module.exports = {"search-destination-root":"SearchDestination_search-destination-root__3J_35","box":"SearchDestination_box__1PMAT"};